/* @flow */
import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import ActionDrawerLocationSelect from './ActionDrawerLocationSelect';

import styles from './ActionDrawerLocation.module.scss';
import { generateUrl, account, company, location } from 'api/routes';

/**
 * ActionDrawerLocation
 *
 * @prop {Object} field
 * @prop {String} accountId
 * @prop {Array<Object>} hierarchy
 * @return {React.Node}
 */
class ActionDrawerLocation extends React.Component<*> {
  @observable hierarchy: Array<Object> = this.props.field.extra.hierarchy
    ? this.props.field.extra.hierarchy.slice()
    : this.props.hierarchy
    ? this.props.hierarchy
    : [];

  handleOnChange = (index: number, value: Object) => {
    const item: Object = this.hierarchy[index];

    item.value = value;

    this.props.field.set(item.type === 'location' && value && value.id ? value.id : '');

    for (let i: number = index + 1; i < this.hierarchy.length; i++) {
      this.hierarchy[i].value = null;
    }
  };

  getUrl = (index: number) => {
    const accountId: string = this.props.accountId;
    let companyId: string = null;
    let countryId: string = null;
    let parentId: string = null;

    for (let i: number = 0; i < this.hierarchy.length; i++) {
      const item: Object = this.hierarchy[i];
      const id: string = item.value && item.value.id ? item.value.id : null;

      switch (item.type) {
        case 'company':
          if (i === index) {
            return generateUrl(account.companies, [accountId]);
          } else if (id) {
            companyId = id;
          } else {
            return null;
          }

          break;
        case 'country':
          if (i === index) {
            return generateUrl(company.countries, [companyId]);
          } else if (id) {
            countryId = id;
          } else {
            return null;
          }

          break;
        case 'location':
          if (i === index) {
            const query = parentId ? `?parent_id=${parentId}` : '';
            return generateUrl(`${location.byCompanyAndCountry}${query}`, [companyId, countryId]);
          } else if (id) {
            parentId = id;
          } else {
            return null;
          }

          break;
        default:
          return null;
      }
    }

    return null;
  };

  render(): React.Node {
    return (
      <div className={styles['form-group']}>
        {this.hierarchy.map((item: Object, index: number) => {
          return (
            <ActionDrawerLocationSelect
              key={index.toString()}
              field={this.props.field}
              name={item.name}
              placeholder={item.placeholder}
              value={item.value}
              type={item.type}
              url={this.getUrl(index)}
              onChange={(value: Object) => {
                this.handleOnChange(index, value);
              }}
            />
          );
        })}
      </div>
    );
  }
}

export default observer(ActionDrawerLocation);
